const initialState = {
  showLauncher: false,
  showWidget: false,
  unreaded: 0,
  isDivWidget: false
};

export const launcher = (state = initialState, action) => {
  switch (action.type) {

    case "SET_INIT":
      return { ...state, isDivWidget: action.isDivWidget }

    case "INIT_SUCCESS":
      return { ...state, unreaded: action.config.unreaded };

    case "SHOW_LAUNCHER":
      if (state.isDivWidget) {
        return { ...state, showLauncher: true, showWidget: true }
      }

      return { ...state, showLauncher: true }

    case "LAUNCHER_CLICKED_ASYNC":
      return { ...state, showWidget: !state.showWidget }

    case "READED_MESSAGE":
      return { 
        ...state,
        unreaded: action.payload.message.unreaded
      };

    case "READ_MESSAGES_SUCCESS":
      return { 
        ...state,
        unreaded: 0
      };

    case "NEW_MESSAGE":
      if (action.payload.message.fromClient) {
        return { ...state };
      }

      if (state.showWidget) {
        return { ...state };
      }

      return { ...state, unreaded: state.unreaded + 1 };
      
    default:
      return state;
  }
};